import { List as OrdersList } from './List';

export default OrdersList;
